<script setup lang="ts">
import HandleQueryStatus from "@/components/HandleQueryStatus.vue";
import SafeHtml from "@/components/SafeHtml.vue";
import { useGetSettings } from "@/settings/settingsCrud";

const { settings, getSettingsStatus } = useGetSettings();
</script>

<template>
  <HandleQueryStatus :query-status="getSettingsStatus">
    <section class="container container-md card">
      <SafeHtml :html="settings?.contactConsentText" />
    </section>
  </HandleQueryStatus>
</template>
